module.exports = __webpack_public_path__ + "static/media/bfile-rv.cdfb3770.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-rv.svg
// module id = 551
// module chunks = 0